import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Box, Stack } from "@mui/system";

export const QueryResultsSkeleton = ({ rowCount = 10, columnCount = 5 }) => {
  return (
    <Paper sx={{ padding: "16px", mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Skeleton variant="rounded" width={100} height={32} />
        <Skeleton variant="rounded" width={120} height={24} />
      </Box>

      <TableContainer
        component={Paper}
        sx={{ boxShadow: "none", border: "1px solid rgba(224, 224, 224, 1)" }}
      >
        <Table size="medium" stickyHeader>
          <TableHead>
            <TableRow>
              {Array.from({ length: columnCount }).map((_, index) => (
                <TableCell key={index} sx={{ fontWeight: "600" }}>
                  <Skeleton variant="rounded" width={100} height={24} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: rowCount }).map((_, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  "& > *": {
                    borderBottom: "1px solid rgba(224, 224, 224, 1) !important",
                  },
                }}
              >
                {Array.from({ length: columnCount }).map((_, cellIndex) => (
                  <TableCell key={cellIndex} sx={{ py: "8px" }}>
                    <Skeleton variant="rounded" width="90%" height={20} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Skeleton pagination */}
      <Stack
        spacing={1}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        padding={1}
      >
        <Box sx={{ width: 120 }}>
          <Skeleton variant="rounded" width={100} height={32} />
        </Box>

        <Box>
          <Skeleton variant="rounded" width={200} height={32} />
        </Box>

        <Box sx={{ width: 120 }}>
          <Skeleton variant="rounded" width={100} height={32} />
        </Box>
      </Stack>
    </Paper>
  );
};
